(async () => {
  if (!customElements.get("product-recommendations")) {
    const { default: Swiper, Navigation } = await import("swiper");
    const { default: Fancybox } = await import("@fancyapps/ui");

    Swiper.use([Navigation]);

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector(
          "[data-swiper-recommended-products]"
        );

        this.swiperOptions = {};

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const dataOptions = parseJson(this.dataset.options);
          if (dataOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...dataOptions,
            };
          }
        }

        this.swiperInstance = new Swiper(
          this.swiperElement,
          this.swiperOptions
        );

        window.onload = () => {
          this.init();
        };
      }

      init() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const source = html.querySelector("[data-recommended-products]");
              const target = this.querySelector("[data-recommended-products]");
              if (
                source &&
                source.innerHTML &&
                source.innerHTML.trim().length
              ) {
                target.innerHTML = source.innerHTML;
              }
              this.swiperInstance.update();
              window.iWishCollectionBinder();
              window.iwishCheckColl();
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define("product-recommendations", ProductRecommendations);
  }
})();
